// ------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template.
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
// ------------------------------------------------------------------------------

import { Dictionary } from '../../../shared/models/dictionary.model';
import { IBaseType } from '../../../shared/enums/ibase-type.enum';

export interface ITonnageRatingDisplayType {
    id: number;
    code: string;
    value: string;
    description: string;
    sortOrder: number;
    active: boolean;
}

export class TonnageRatingDisplayType implements ITonnageRatingDisplayType, IBaseType {
    public id: number;
    public code: string;
    public value: string;
    public description: string;
    public sortOrder: number;
    public active: boolean;

    /**
		Returns 1/4 TonnageRatingDisplayType
	**/
    get A(): ITonnageRatingDisplayType {
        return this.FromId(1);
    }
    /**
		Returns 1/2 TonnageRatingDisplayType
	**/
    get B(): ITonnageRatingDisplayType {
        return this.FromId(2);
    }
    /**
		Returns 3/4 TonnageRatingDisplayType
	**/
    get C(): ITonnageRatingDisplayType {
        return this.FromId(3);
    }
    /**
		Returns 1 TonnageRatingDisplayType
	**/
    get D(): ITonnageRatingDisplayType {
        return this.FromId(4);
    }
    /**
		Returns 1 1/2 TonnageRatingDisplayType
	**/
    get E(): ITonnageRatingDisplayType {
        return this.FromId(5);
    }
    /**
		Returns 1 3/4 TonnageRatingDisplayType
	**/
    get F(): ITonnageRatingDisplayType {
        return this.FromId(6);
    }
    /**
		Returns 2 TonnageRatingDisplayType
	**/
    get G(): ITonnageRatingDisplayType {
        return this.FromId(7);
    }
    /**
		Returns 2 1/2 TonnageRatingDisplayType
	**/
    get H(): ITonnageRatingDisplayType {
        return this.FromId(8);
    }
    /**
		Returns 3 TonnageRatingDisplayType
	**/
    get I(): ITonnageRatingDisplayType {
        return this.FromId(9);
    }
    /**
		Returns 3 1/2 TonnageRatingDisplayType
	**/
    get J(): ITonnageRatingDisplayType {
        return this.FromId(10);
    }
    /**
		Returns 4 TonnageRatingDisplayType
	**/
    get K(): ITonnageRatingDisplayType {
        return this.FromId(11);
    }
    /**
		Returns 4 1/2 TonnageRatingDisplayType
	**/
    get L(): ITonnageRatingDisplayType {
        return this.FromId(12);
    }
    /**
		Returns 5 TonnageRatingDisplayType
	**/
    get M(): ITonnageRatingDisplayType {
        return this.FromId(13);
    }
    /**
		Returns 6 TonnageRatingDisplayType
	**/
    get N(): ITonnageRatingDisplayType {
        return this.FromId(14);
    }
    /**
		Returns 7 TonnageRatingDisplayType
	**/
    get O(): ITonnageRatingDisplayType {
        return this.FromId(15);
    }
    /**
		Returns 8 TonnageRatingDisplayType
	**/
    get P(): ITonnageRatingDisplayType {
        return this.FromId(16);
    }
    /**
		Returns 9 TonnageRatingDisplayType
	**/
    get X1(): ITonnageRatingDisplayType {
        return this.FromId(18);
    }
    /**
		Returns 10 TonnageRatingDisplayType
	**/
    get R(): ITonnageRatingDisplayType {
        return this.FromId(17);
    }
    /**
		Returns 11 TonnageRatingDisplayType
	**/
    get X2(): ITonnageRatingDisplayType {
        return this.FromId(19);
    }
    /**
		Returns 12 TonnageRatingDisplayType
	**/
    get X3(): ITonnageRatingDisplayType {
        return this.FromId(20);
    }
    /**
		Returns 13 TonnageRatingDisplayType
	**/
    get X4(): ITonnageRatingDisplayType {
        return this.FromId(21);
    }
    /**
		Returns 14 TonnageRatingDisplayType
	**/
    get X5(): ITonnageRatingDisplayType {
        return this.FromId(22);
    }
    /**
		Returns 15 TonnageRatingDisplayType
	**/
    get X6(): ITonnageRatingDisplayType {
        return this.FromId(23);
    }
    /**
		Returns 16 TonnageRatingDisplayType
	**/
    get X7(): ITonnageRatingDisplayType {
        return this.FromId(24);
    }
    /**
		Returns 17 TonnageRatingDisplayType
	**/
    get X8(): ITonnageRatingDisplayType {
        return this.FromId(25);
    }
    /**
		Returns 18 TonnageRatingDisplayType
	**/
    get X9(): ITonnageRatingDisplayType {
        return this.FromId(26);
    }
    /**
		Returns 19 TonnageRatingDisplayType
	**/
    get X10(): ITonnageRatingDisplayType {
        return this.FromId(27);
    }
    /**
		Returns 20 TonnageRatingDisplayType
	**/
    get X11(): ITonnageRatingDisplayType {
        return this.FromId(28);
    }
    /**
		Returns 21 TonnageRatingDisplayType
	**/
    get X12(): ITonnageRatingDisplayType {
        return this.FromId(29);
    }
    /**
		Returns 22 TonnageRatingDisplayType
	**/
    get X13(): ITonnageRatingDisplayType {
        return this.FromId(30);
    }
    /**
		Returns 23 TonnageRatingDisplayType
	**/
    get X14(): ITonnageRatingDisplayType {
        return this.FromId(31);
    }
    /**
		Returns 24 TonnageRatingDisplayType
	**/
    get X15(): ITonnageRatingDisplayType {
        return this.FromId(32);
    }
    /**
		Returns 25 TonnageRatingDisplayType
	**/
    get X16(): ITonnageRatingDisplayType {
        return this.FromId(33);
    }
    /**
		Returns 26 TonnageRatingDisplayType
	**/
    get X17(): ITonnageRatingDisplayType {
        return this.FromId(34);
    }
    /**
		Returns 27 TonnageRatingDisplayType
	**/
    get X18(): ITonnageRatingDisplayType {
        return this.FromId(35);
    }
    /**
		Returns 28 TonnageRatingDisplayType
	**/
    get X19(): ITonnageRatingDisplayType {
        return this.FromId(36);
    }
    /**
		Returns 29 TonnageRatingDisplayType
	**/
    get X20(): ITonnageRatingDisplayType {
        return this.FromId(37);
    }
    /**
		Returns 30 TonnageRatingDisplayType
	**/
    get X21(): ITonnageRatingDisplayType {
        return this.FromId(38);
    }
    /**
		Returns 31 TonnageRatingDisplayType
	**/
    get X22(): ITonnageRatingDisplayType {
        return this.FromId(39);
    }
    /**
		Returns 32 TonnageRatingDisplayType
	**/
    get X23(): ITonnageRatingDisplayType {
        return this.FromId(40);
    }
    /**
		Returns 33 TonnageRatingDisplayType
	**/
    get X24(): ITonnageRatingDisplayType {
        return this.FromId(41);
    }
    /**
		Returns 34 TonnageRatingDisplayType
	**/
    get X25(): ITonnageRatingDisplayType {
        return this.FromId(42);
    }
    /**
		Returns 35 TonnageRatingDisplayType
	**/
    get X26(): ITonnageRatingDisplayType {
        return this.FromId(43);
    }
    /**
		Returns 36 TonnageRatingDisplayType
	**/
    get X27(): ITonnageRatingDisplayType {
        return this.FromId(44);
    }
    /**
		Returns 37 TonnageRatingDisplayType
	**/
    get X28(): ITonnageRatingDisplayType {
        return this.FromId(45);
    }
    /**
		Returns 38 TonnageRatingDisplayType
	**/
    get X29(): ITonnageRatingDisplayType {
        return this.FromId(46);
    }
    /**
		Returns 39 TonnageRatingDisplayType
	**/
    get X30(): ITonnageRatingDisplayType {
        return this.FromId(47);
    }
    /**
		Returns 40 TonnageRatingDisplayType
	**/
    get X31(): ITonnageRatingDisplayType {
        return this.FromId(48);
    }

    private _dictionary: Dictionary = new Dictionary([]);

    constructor() {
        this._dictionary.add('1', { id: 1, code: 'A', value: '1/4', description: 'Quarter Ton', sortOrder: 1, active: true });
        this._dictionary.add('2', { id: 2, code: 'B', value: '1/2', description: 'Half Ton', sortOrder: 2, active: true });
        this._dictionary.add('3', { id: 3, code: 'C', value: '3/4', description: 'Three Quarter Ton', sortOrder: 3, active: true });
        this._dictionary.add('4', { id: 4, code: 'D', value: '1', description: 'One Ton', sortOrder: 4, active: true });
        this._dictionary.add('5', { id: 5, code: 'E', value: '1 1/2', description: 'One and a Half Ton', sortOrder: 5, active: true });
        this._dictionary.add('6', { id: 6, code: 'F', value: '1 3/4', description: 'One and Three Quarter Ton', sortOrder: 6, active: true });
        this._dictionary.add('7', { id: 7, code: 'G', value: '2', description: 'Two Ton', sortOrder: 7, active: true });
        this._dictionary.add('8', { id: 8, code: 'H', value: '2 1/2', description: 'Two and a Half Ton', sortOrder: 8, active: true });
        this._dictionary.add('9', { id: 9, code: 'I', value: '3', description: 'Three Ton', sortOrder: 9, active: true });
        this._dictionary.add('10', { id: 10, code: 'J', value: '3 1/2', description: 'Three and a Half Ton', sortOrder: 10, active: true });
        this._dictionary.add('11', { id: 11, code: 'K', value: '4', description: 'Four Ton', sortOrder: 11, active: true });
        this._dictionary.add('12', { id: 12, code: 'L', value: '4 1/2', description: 'Four and a Half Ton', sortOrder: 12, active: true });
        this._dictionary.add('13', { id: 13, code: 'M', value: '5', description: 'Five Ton', sortOrder: 13, active: true });
        this._dictionary.add('14', { id: 14, code: 'N', value: '6', description: 'Six Ton', sortOrder: 14, active: true });
        this._dictionary.add('15', { id: 15, code: 'O', value: '7', description: 'Seven Ton', sortOrder: 15, active: true });
        this._dictionary.add('16', { id: 16, code: 'P', value: '8', description: 'Eight Ton', sortOrder: 16, active: true });
        this._dictionary.add('18', { id: 18, code: 'X1', value: '9', description: 'Nine Ton', sortOrder: 17, active: true });
        this._dictionary.add('17', { id: 17, code: 'R', value: '10', description: 'Ten Ton', sortOrder: 18, active: true });
        this._dictionary.add('19', { id: 19, code: 'X2', value: '11', description: 'Eleven Ton', sortOrder: 19, active: true });
        this._dictionary.add('20', { id: 20, code: 'X3', value: '12', description: 'Twelve Ton', sortOrder: 20, active: true });
        this._dictionary.add('21', { id: 21, code: 'X4', value: '13', description: 'Thirteen Ton', sortOrder: 21, active: true });
        this._dictionary.add('22', { id: 22, code: 'X5', value: '14', description: 'Fourteen Ton', sortOrder: 22, active: true });
        this._dictionary.add('23', { id: 23, code: 'X6', value: '15', description: 'Fifteen Ton', sortOrder: 23, active: true });
        this._dictionary.add('24', { id: 24, code: 'X7', value: '16', description: 'Sixteen Ton', sortOrder: 24, active: true });
        this._dictionary.add('25', { id: 25, code: 'X8', value: '17', description: 'Seventeen Ton', sortOrder: 25, active: true });
        this._dictionary.add('26', { id: 26, code: 'X9', value: '18', description: 'Eighteen Ton', sortOrder: 26, active: true });
        this._dictionary.add('27', { id: 27, code: 'X10', value: '19', description: 'Nineteen Ton', sortOrder: 27, active: true });
        this._dictionary.add('28', { id: 28, code: 'X11', value: '20', description: 'Twenty Ton', sortOrder: 28, active: true });
        this._dictionary.add('29', { id: 29, code: 'X12', value: '21', description: 'Twenty One Ton', sortOrder: 29, active: true });
        this._dictionary.add('30', { id: 30, code: 'X13', value: '22', description: 'Twenty Two Ton', sortOrder: 30, active: true });
        this._dictionary.add('31', { id: 31, code: 'X14', value: '23', description: 'Twenty Three Ton', sortOrder: 31, active: true });
        this._dictionary.add('32', { id: 32, code: 'X15', value: '24', description: 'Twenty Four Ton', sortOrder: 32, active: true });
        this._dictionary.add('33', { id: 33, code: 'X16', value: '25', description: 'Twenty Five Ton', sortOrder: 33, active: true });
        this._dictionary.add('34', { id: 34, code: 'X17', value: '26', description: 'Twenty Six Ton', sortOrder: 34, active: true });
        this._dictionary.add('35', { id: 35, code: 'X18', value: '27', description: 'Twenty Seven Ton', sortOrder: 35, active: true });
        this._dictionary.add('36', { id: 36, code: 'X19', value: '28', description: 'Twenty Eight Ton', sortOrder: 36, active: true });
        this._dictionary.add('37', { id: 37, code: 'X20', value: '29', description: 'Twenty Nine Ton', sortOrder: 37, active: true });
        this._dictionary.add('38', { id: 38, code: 'X21', value: '30', description: 'Thirty Ton', sortOrder: 38, active: true });
        this._dictionary.add('39', { id: 39, code: 'X22', value: '31', description: 'Thirty One Ton', sortOrder: 39, active: true });
        this._dictionary.add('40', { id: 40, code: 'X23', value: '32', description: 'Thirty Two Ton', sortOrder: 40, active: true });
        this._dictionary.add('41', { id: 41, code: 'X24', value: '33', description: 'Thirty Three Ton', sortOrder: 41, active: true });
        this._dictionary.add('42', { id: 42, code: 'X25', value: '34', description: 'Thirty Four Ton', sortOrder: 42, active: true });
        this._dictionary.add('43', { id: 43, code: 'X26', value: '35', description: 'Thity Five Ton', sortOrder: 43, active: true });
        this._dictionary.add('44', { id: 44, code: 'X27', value: '36', description: 'Thirty Six Ton', sortOrder: 44, active: true });
        this._dictionary.add('45', { id: 45, code: 'X28', value: '37', description: 'Thirty Seven Ton', sortOrder: 45, active: true });
        this._dictionary.add('46', { id: 46, code: 'X29', value: '38', description: 'Thirty Eight Ton', sortOrder: 46, active: true });
        this._dictionary.add('47', { id: 47, code: 'X30', value: '39', description: 'Thirty Nine Ton', sortOrder: 47, active: true });
        this._dictionary.add('48', { id: 48, code: 'X31', value: '40', description: 'Forty Ton', sortOrder: 48, active: true });
    }

    public ToString(): string {
        return this.value == null ? null : this.value.toString();
    }

    public FromId(id: number): ITonnageRatingDisplayType {
        return this._dictionary[id];
    }

    public FromCode(code: string): ITonnageRatingDisplayType {
        var match = this._dictionary.getValues().filter(d => d.value == code);

        if (match.length > 0) {
            return this._dictionary[match[0].id];
        } else {
            return undefined;
        }
    }

    public GetAll(): ITonnageRatingDisplayType[] {
        return this._dictionary.getValues().sort(this.sort_by('sortOrder', false, null, this.sort_by('displayValue', false, null, null)));
    }

    public GetActive(): ITonnageRatingDisplayType[] {
        return this.GetAll().filter(d => d.active);
    }

    public Sort(primaryField, secondaryField, reverse): ITonnageRatingDisplayType[] {
        return this.GetAll().sort(this.sort_by(primaryField, reverse, null, secondaryField != null ? this.sort_by(secondaryField, reverse, null, null) : null));
    }

    private sort_by = (path, reverse, primer, then) => {
        var get = (obj, path) => {
                if (path) {
                    path = path.split('.');

                    for (var i = 0, len = path.length - 1; i < len; i++) {
                        obj = obj[path[i]];
                    }

                    return obj[path[len]];
                }
                return obj;
            },
            prime = (obj) => primer ? primer(get(obj, path)) : get(obj, path);

        return (a, b) => {
            var A = prime(a),
                B = prime(b);

            return (
                (A < B) ? -1 :
                    (A > B) ? 1 :
                        (typeof then === 'function') ? then(a, b) : 0
            ) * [1, -1][+!!reverse];
        };
    };
}
